import { render, staticRenderFns } from "./ListPrimaVacacional.vue?vue&type=template&id=b3b9d858&"
import script from "./ListPrimaVacacional.vue?vue&type=script&lang=js&"
export * from "./ListPrimaVacacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports